import { AssetTypes } from "@eave/shared/types/api";
import * as React from "react";

/* rendering */

export const EMDASH = <span className="asset-summary__emdash">—</span>;

/* account names */

export const prependEllipsis = str => `…${str}`;

export const appendPercentageSign = str => `${str}%`;

export const acctToTitleStr = acct => {
  const { name, number_suffix, institution } = acct;

  if (name && number_suffix) {
    return (
      <span>
        {name} ({prependEllipsis(number_suffix)})
      </span>
    );
  }
  if (name) {
    return <span>{name}</span>;
  }
  if (number_suffix) {
    return <span>{prependEllipsis(number_suffix)}</span>;
  }
  if (institution) {
    return <span>{institution} account</span>;
  }

  return <span>account</span>;
};

export const acctToTitleStrOnly = (acct): string => {
  const { name, number_suffix, institution } = acct;

  if (name && number_suffix) {
    return `${name} (${prependEllipsis(number_suffix)})`;
  }
  if (name) {
    return name;
  }
  if (number_suffix) {
    return prependEllipsis(number_suffix);
  }
  if (institution) {
    return `${institution} account`;
  }

  return "account";
};

/* account types */

// TODO: jjw: get dynamically from backend (cf. underwriting/asset_types.go)

export const assetTypeIsExoticOrIlliquidAsset = (t: AssetTypes): boolean => {
  const arr = {
    [AssetTypes.StockBrokerageAccount]: true,
  };
  return Boolean(arr[t]);
};

/* misc string helpers */
export const stripSymbols = (value: string): string => {
  if (value === "") {
    return "";
  }

  return value.trim().replaceAll(",", "").replaceAll("$", "");
};
